export default "__VITE_ASSET__CjXUboAB__"